// src/components/SmartLink.tsx
import React from "react"
import { Link as GatsbyLink, navigate } from "gatsby"

const isInternal = (to: string) => /^\/(?!\/)/.test(to)

const scrollToSection = (sectionId: string) => {
  if (!sectionId) return

  const tryScroll = () => {
    const element = document.getElementById(sectionId)
    const header = document.getElementById("header-wrapper")

    if (element) {
      const headerHeight = header?.offsetHeight || 80
      const y =
        element.getBoundingClientRect().top + window.scrollY - headerHeight

      window.scrollTo({
        top: y,
        behavior: "smooth",
      })
      return true
    }
    return false
  }

  let attempts = 0
  const interval = setInterval(() => {
    if (tryScroll() || attempts > 20) {
      clearInterval(interval)
    }
    attempts++
  }, 50)
}

const SmartLink = ({
  children,
  to,
  activeClassName = "",
  partiallyActive = false,
  onClick,
  ...other
}: {
  children: React.ReactNode
  to: string
  activeClassName?: string
  partiallyActive?: boolean
  onClick?: any
  [key: string]: any
}) => {
  const internal = isInternal(to)

  if (!internal) {
    return (
      <a href={to} {...other}>
        {children}
      </a>
    )
  }

  const [path, queryString] = to.split("?")
  const params = new URLSearchParams(queryString)
  const section = params.get("section")

  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : ""

  const isSamePage = currentPath === path

  // Clone params so we can safely modify
  const finalParams = new URLSearchParams(params)

  // Remove section param when staying on same page
  if (section && isSamePage) {
    finalParams.delete("section")
  }

  // Build final query string
  const finalQuery = finalParams.toString()
  const finalTo = finalQuery ? `${path}?${finalQuery}` : path

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e)
    }
    if (!section) return

    // Same page → just scroll, no URL change
    if (isSamePage) {
      e.preventDefault()
      scrollToSection(section)
      return
    }

    // Different page → allow URL param, but still control navigation
    e.preventDefault()
    navigate(finalTo)
    // scrollToSection(section)
  }

  return (
    <GatsbyLink
      to={finalTo}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      onClick={handleClick}
      {...other}
    >
      {children}
    </GatsbyLink>
  )
}

export default SmartLink
